import { useEffect, useState } from "react";
import { fetchGlobalSettings } from "../api/axios";

const useGlobalSettings = () => {
  const [globalData, setGlobalData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchGlobalSettings()
      .then((data) => setGlobalData(data))
      .finally(() => setLoading(false));
  }, []);

  return { globalData, loading };
};

export default useGlobalSettings;
